export default "deee82114af651c3.png"